 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-007fd6ca":"9280af07","chunk-6a09513e":"9e4b7fb6","chunk-7e8241c8":"b670ac4a","chunk-03edd7b8":"4fb65938","chunk-2d0ac03c":"3295e10d","chunk-2d0c0856":"1f3ecc27","chunk-212367d0":"8afd8b07","chunk-2b278ee7":"46cb354d","chunk-2d0b2158":"86359493","chunk-2d0cfeb3":"295324a3","chunk-2d0d2f90":"43902383","chunk-2d2163d4":"b47db21c","chunk-2d627211":"aec066a4","chunk-376884b6":"a32f56e3","chunk-3768c625":"3a0cff62","chunk-3768c647":"6ec73390","chunk-3768f920":"bbc7ef3e","chunk-3768f94e":"899ff428","chunk-376900b2":"aef06c9a","chunk-37697ca5":"144ea3f0","chunk-3769e020":"3ac963df","chunk-376a6cff":"67312fed","chunk-376a941d":"ee7a05e8","chunk-376acc6c":"79ddc116","chunk-376acc7e":"1d28afcd","chunk-376acca9":"2db206d2","chunk-376b809c":"54aa0d5b","chunk-376bfecc":"c2a66e9e","chunk-376c3eab":"9600411d","chunk-376c6d21":"c1683196","chunk-376c708f":"48ee929f","chunk-376cef0f":"0bc3aa20","chunk-377e5862":"ee6ae5f9","chunk-377e7527":"ef938c46","chunk-377ed9f8":"c689ab09","chunk-377f12a5":"a08ff2f2","chunk-377f14a2":"6110d771","chunk-377f5235":"ec5121b6","chunk-377f9005":"53a99ae2","chunk-377fada0":"d1e3e33c","chunk-377fbbbf":"3fc6dd74","chunk-3780970d":"c6db49f1","chunk-3780a904":"acb9dab5","chunk-3780ad51":"3d3a1069","chunk-3780b720":"2a70747f","chunk-3780de1e":"bd4ac48e","chunk-3780e609":"b38bd25f","chunk-3780ed6d":"eabed6db","chunk-3781564e":"e0c98eca","chunk-4e4f0389":"39505ad9","chunk-6d11602e":"873b64e1","chunk-4de13e6c":"16cb7743"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-6a09513e":1,"chunk-7e8241c8":1,"chunk-03edd7b8":1,"chunk-2b278ee7":1,"chunk-2d627211":1,"chunk-4e4f0389":1,"chunk-6d11602e":1,"chunk-4de13e6c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-007fd6ca":"31d6cfe0","chunk-6a09513e":"263cc7c8","chunk-7e8241c8":"bf08febf","chunk-03edd7b8":"74c83d0a","chunk-2d0ac03c":"31d6cfe0","chunk-2d0c0856":"31d6cfe0","chunk-212367d0":"31d6cfe0","chunk-2b278ee7":"f3864427","chunk-2d0b2158":"31d6cfe0","chunk-2d0cfeb3":"31d6cfe0","chunk-2d0d2f90":"31d6cfe0","chunk-2d2163d4":"31d6cfe0","chunk-2d627211":"18af390c","chunk-376884b6":"31d6cfe0","chunk-3768c625":"31d6cfe0","chunk-3768c647":"31d6cfe0","chunk-3768f920":"31d6cfe0","chunk-3768f94e":"31d6cfe0","chunk-376900b2":"31d6cfe0","chunk-37697ca5":"31d6cfe0","chunk-3769e020":"31d6cfe0","chunk-376a6cff":"31d6cfe0","chunk-376a941d":"31d6cfe0","chunk-376acc6c":"31d6cfe0","chunk-376acc7e":"31d6cfe0","chunk-376acca9":"31d6cfe0","chunk-376b809c":"31d6cfe0","chunk-376bfecc":"31d6cfe0","chunk-376c3eab":"31d6cfe0","chunk-376c6d21":"31d6cfe0","chunk-376c708f":"31d6cfe0","chunk-376cef0f":"31d6cfe0","chunk-377e5862":"31d6cfe0","chunk-377e7527":"31d6cfe0","chunk-377ed9f8":"31d6cfe0","chunk-377f12a5":"31d6cfe0","chunk-377f14a2":"31d6cfe0","chunk-377f5235":"31d6cfe0","chunk-377f9005":"31d6cfe0","chunk-377fada0":"31d6cfe0","chunk-377fbbbf":"31d6cfe0","chunk-3780970d":"31d6cfe0","chunk-3780a904":"31d6cfe0","chunk-3780ad51":"31d6cfe0","chunk-3780b720":"31d6cfe0","chunk-3780de1e":"31d6cfe0","chunk-3780e609":"31d6cfe0","chunk-3780ed6d":"31d6cfe0","chunk-3781564e":"31d6cfe0","chunk-4e4f0389":"84f98409","chunk-6d11602e":"b5f32203","chunk-4de13e6c":"3102a1b1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://3m.dataviz-unicef.id/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
